<template>
  <div v-if="visible" class="h-screen fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 cursor-not-allowed">
    <div class="flex flex-col items-center justify-center text-white">
      <ProgressSpinner style="width: 60px; height: 60px" strokeWidth="5" fill="transparent" animationDuration=".5s" />
      <span>{{ text ? text : "Cargando..." }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import ProgressSpinner from 'primevue/progressspinner';

export default defineComponent({
  components: {
    ProgressSpinner
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: false
    }
  }
});
</script>